import {
  createSlice
} from "@reduxjs/toolkit";
import {
  showNotification
} from "./notificationSlice";
import {
  factory
} from "../../api/apiFactory";
const caseTypeApi = factory.get("caseType");
const initialState = {
  loading: false,
  searchBody: {},
  caseType: {
    dialog: false,
    form: {
      id: "",
      name: "",
      section_id: null,
      price: "",
      discount: "",
      note: "",
    },
  },
  caseTypes: {
    data: [],
    total: 0,
  },
}

export const caseTypeSlice = createSlice({
  name: "caseType",
  initialState,
  reducers: {
    setDialog: (state, action) => {
      state.caseType.dialog = !state.caseType.dialog
    },
    setDataTable: (state, {
      payload
    }) => {
      state.caseTypes.data = payload.data.data
      state.caseTypes.total = payload.data.total
    },
    setDatalist: (state, {
      payload
    }) => {
      state.sectionsList.data = payload.data.data
      state.sectionsList.total = payload.data.total
    },
    setById: (state, {
      payload
    }) => {
      state.caseType.form.id = payload.id
      state.caseType.form.name = payload.name
      state.caseType.form.section_id = payload.section_id
      state.caseType.form.price = payload.price
      state.caseType.form.discount = payload.discount
      state.caseType.form.note = payload.note
    },
    setLoading: (state, action) => {
      state.loading = !state.loading;
    },
    resetForm: (state, action) => {
      state.caseType.form = initialState.caseType.form
    },
    setSearchBody: (state, {
      payload
    }) => {
      state.searchBody = payload;
    },
  }
})

export const {
  setLoading,
  setDialog,
  setById,
  setDataTable,
  resetForm,
  setSearchBody,
  setDatalist
} = caseTypeSlice.actions

export default caseTypeSlice.reducer;

//axios
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading('caseType'));
    const res = await caseTypeApi.getAll(params)
    dispatch(setDataTable(res));
    dispatch(setLoading('caseType'));

  } catch (err) {
    dispatch(setLoading('caseType'));
    dispatch(showNotification({
      message: err.response.data.errors[0],
      type: "error"
    }));
    throw new Error(err);
  }
};
const getAllList = (params) => async (dispatch) => {
  try {
    dispatch(setLoading('caseType'));
    const res = await caseTypeApi.getAllList(params)
    dispatch(setDatalist(res));
    dispatch(setLoading('caseType'));
  } catch (err) {
    dispatch(setLoading('caseType'));
    dispatch(showNotification({
      message: err.response.data.errors[0],
      type: "error"
    }));
    throw new Error(err);
  }
};
const deleteById = (id, _SearchBody) => async (dispatch) => {
  try {
    await caseTypeApi.delete(id)
    dispatch(showNotification({
      message: "تم الحذف بنجاح",
      type: "success"
    }));
    dispatch(getAll(_SearchBody))
  } catch (err) {
    dispatch(showNotification({
      message: err.response.data.errors[0],
      type: "error"
    }));
    throw new Error(err);
  }
};
const getById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading('caseType'));
    const res = await caseTypeApi.getById(id)
    dispatch(setById(res.data.data[0]));

    dispatch(setDialog())
    dispatch(setLoading('caseType'));
  } catch (err) {
    dispatch(setLoading('caseType'));
    dispatch(showNotification({
      message: err.response.data.errors[0],
      type: "error"
    }));
    throw new Error(err);
  }
};
const create = (data, _SearchBody) => async (dispatch) => {
  try {
    await caseTypeApi.create(data)
    dispatch(showNotification({
      message: "تمت الاضافة  بنجاح",
      type: "success"
    }));
    dispatch(setDialog())
    dispatch(getAll(_SearchBody))
  } catch (err) {
    dispatch(showNotification({
      message: err.response.data.errors[0],
      type: "error"
    }));
    throw new Error(err);
  }
};
const update = (id, data, _SearchBody) => async (dispatch) => {
  try {
    await caseTypeApi.update(id, data)
    dispatch(showNotification({
      message: "تم التعديل  بنجاح",
      type: "success"
    }));
    dispatch(setDialog())
    dispatch(getAll(_SearchBody))
  } catch (err) {
    dispatch(showNotification({
      message: err.response.data.errors[0],
      type: "error"
    }));
    throw new Error(err);
  }
};

export const CaseType = {
  getAll,
  deleteById,
  getById,
  create,
  update,
  getAllList
}